import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: sessionStorage.getItem('CMSVuexState') ? JSON.parse(sessionStorage.getItem('CMSVuexState')) : {
        // 行业动态详情ID
        industryId: '',
        // 所属组织部ID
        deptId: '',
        user: {}
    },
    mutations: {
        changeIndustryId(state, id) {
            state.industryId = id;
        },
        changeDeptId(state, id) {
            state.deptId = id;
        },
        changeUser(state, data) {
            state.user = data;
        }
    },
    actions: {
    },
    modules: {
    }
});
